<template>
  <el-row type="flex" justify="end">
    <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
      <el-input
        :placeholder="$t('pesquisar')"
        prefix-icon="el-icon-search"
        v-model="filter"
        v-on:keyup.native.enter="fetch()" 
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="fetch"
        ></el-button>
      </el-input>
    </el-col>
    <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
      <el-button
        class="right"
        type="primary"
        icon="el-icon-plus"
        @click="add()"
        >{{ $t("adicionar") }}</el-button
      >
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "ShippingHeaderSearch",
  props: ['redirect'],
  data() {
    return {
      filter: "",
    }
  },
  methods: {
    add() {
      this.$router.replace({ name: this.redirect });
    },
    fetch() {
      this.$emit("fetch", this.filter);
    },
  },
}
</script>